import appConstants from "../../../../../../appConstants";

const gridShortHeaderNamesConfig = {
  driverNumber: {
    headerName: "Driver #",
    minWidth: appConstants.columnWidth.W_100,
  },
  msg: {
    headerName: "MSG",
    minWidth: appConstants.columnWidth.W_65,
  },
  lastActionTime: {
    headerName: "Last Act",
    minWidth: appConstants.columnWidth.W_95,
  },
  elapsedTime: {
    headerName: "Elaps Time",
    minWidth: appConstants.columnWidth.W_120,
  },
  compDel: {
    headerName: "C",
    minWidth: appConstants.columnWidth.W_62,
  },
  pendingDel: {
    headerName: "P",
    minWidth: appConstants.columnWidth.W_62,
  },
  returnDel: {
    headerName: "R",
    minWidth: appConstants.columnWidth.W_62,
  },
  totalDel: {
    headerName: "T",
    minWidth: appConstants.columnWidth.W_62,
  },
  completedPickups: {
    headerName: "C",
    minWidth: appConstants.columnWidth.W_62,
  },
  unAcknowledgedPickups: {
    headerName: "UA",
    minWidth: appConstants.columnWidth.W_65,
  },
  pendingPickups: {
    headerName: "P",
    minWidth: appConstants.columnWidth.W_62,
  },
  noFreightPickups: {
    headerName: "NF",
    minWidth: appConstants.columnWidth.W_65,
  },
  totalPickups: {
    headerName: "T",
    minWidth: appConstants.columnWidth.W_62,
  },
  totalHU: {
    headerName: "Tot HU",
    minWidth: appConstants.columnWidth.W_90,
  },
  totalWeight: {
    headerName: "Tot Wgt",
    minWidth: appConstants.columnWidth.W_95,
  },
  totalPcs: {
    headerName: "Tot Pcs",
    minWidth: appConstants.columnWidth.W_90,
  },
  occCapacity: {
    headerName: "Trl Cap",
    minWidth: appConstants.columnWidth.W_90,
  },
};

const DRIVER_GRID_COMMANDS = {
  DISPATCH: 'Dispatch',
  ASSIGN: 'Assign',
  UNASSIGN: 'Unassign',
  REASSIGN: 'Reassign',
};

export { gridShortHeaderNamesConfig, DRIVER_GRID_COMMANDS };
